import React from 'react';
import cx from 'classnames';

import { FilterSearchBox } from '@components/search/filterSearchBox';

import Exit from '@svg/exit-white.svg';

export const MobileSearch = ({ setSearchOpen, searchOpen }) => {
  //listen for <enter> key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setSearchOpen(false);
    }
  };

  //run handleKeyPress on key press
  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyPress, { passive: true });
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div
      className={cx(
        'bg-teal w-full fixed top-0 left-0 transition-standard z-50',
        {
          'opacity-0 pointer-events-none': !searchOpen,
          'opacity-100': searchOpen,
        },
      )}>
      <div className='min-h-screen flex flex-col items-center justify-center'>
        <div className='absolute top-10 right-gutter'>
          <button
            onClick={() => setSearchOpen(false)}
            className='w-12 h-12 rounded-full bg-white bg-opacity-10 flex items-center justify-center'>
            <Exit className='p-[3px]' />
          </button>
        </div>
        <div className='w-full px-gutter'>
          <span className='blockH2 text-white mb-10 block text-center'>
            Search Events
          </span>
          <FilterSearchBox setSearchOpen={setSearchOpen} />
        </div>
      </div>
    </div>
  );
};
